import { useAuthContext } from '@/hooks/useAuthContext';
import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }: PropsWithChildren) {
  const { isAuthenticated, isInitialized } = useAuthContext();
  if (isAuthenticated) {
    return <Navigate to="/dashboard/app" />;
  }

 

  return <> {children} </>;
}
